<template>
  <div class="allbox">
    <div style="margin-bottom:20px;">
      <div class="condition">
        <el-input
          v-model="query.user_id"
          class="inptw"
          placeholder="主账号id"
        />
        <el-input
          v-model="query.sub_uc_id"
          class="inptw"
          placeholder="子账号id"
        />
        <el-input
          v-model="query.projectFeedId"
          class="inptw"
          placeholder="智投项目id"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
        >搜索</el-button>
      </div>
    </div>
    <el-table
      :data="baidudataList"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column
        prop="projectFeedId"
        label="项目id"
        width="120px"
      />
      <el-table-column
        prop="projectFeedName"
        label="项目名称"
        width="180px"
      />
      <el-table-column
        prop="statusText"
        label="项目状态"
        width="150px"
      />
      <el-table-column
        prop="appInfo"
        label="推广APP信息"
        width="230px"
      >
        <template slot-scope="scope">
          <el-button @click="appInfoLook(scope.row.appInfo)">查看app详情信息</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="bidModeText"
        label="出价模式"
        width="80px"
      />
      <el-table-column
        prop="campaignFeedIds"
        label="项目关联的计划ID集合"
        width="80px"
      >
        <template slot-scope="scope">
          <el-tag v-for="item,index in scope.row.campaignFeedIds" :key="index">{{ item }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="catalogId"
        label="产品分组id"
        width="120px"
      />
      <el-table-column
        prop="catalogSourceText"
        label="产品库来源"
        width="150px"
      />
      <el-table-column
        prop="productTypeText"
        label="产品库类型"
        width="150px"
      />
      <el-table-column
        prop="appSubTypeText"
        label="推广场景"
        width="150px"
      />
      <el-table-column
        label="oCPC信息"
        width="150px"
      >
        <template slot-scope="scope">
          <el-button style="margin-left: 16px;" type="text" @click="openoCPC(scope.row.ocpc)">查看oCPC信息</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="productIds"
        label="产品id"
        width="150px"
      />
      <el-table-column
        prop="projectOcpxStatusText"
        label="项目学习状态"
        width="150px"
      />
      <el-table-column
        prop="sub_uc_id"
        label="sub_uc_id"
        width="150px"
      />
      <el-table-column
        prop="subjectText"
        label="营销目标"
        width="150px"
      />
      <el-table-column
        label="推广范围"
        width="200px"
      >
        <template slot-scope="scope">
          <el-tag
            v-for="item,index in scope.row.ftypesText"
            :key="index"
            class="tag_box"
          >
            {{ item }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="添加时间"
        width="150px"
      />
      <el-table-column
        prop="pauseText"
        label="项目启停"
        width="150px"
      />
    </el-table>
    <el-drawer
      title="详细信息"
      :visible.sync="isDialogVisible"
      direction="rtl"
      size="50%"
    >
      <ocpc-info-table ref="ocpcInfo" :ocpc_info="ocpc_info" />
    </el-drawer>
    <el-drawer
      title="详细信息"
      :visible.sync="appInfoDialogVisible"
      direction="rtl"
      size="50%"
    >
      <appInfo ref="appInfo" :app_info="app_info" />
    </el-drawer>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>

import { getBaiduADProjectFeedList } from '@/api/baiduAD'
import PaginationRight from '@/components/PaginationRight/index.vue'
import OcpcInfoTable from '@/views/baiduAD/components/ocpcInfoTable.vue'
import AppInfo from '@/views/baiduAD/components/appInfo.vue'

export default {
  components: { AppInfo, OcpcInfoTable, PaginationRight },
  data() {
    return {
      baidudataList: [],
      total: 50,
      page: 1,
      query: {
        user_id: '',
        sub_uc_id: '',
        projectFeedId: '',
        page: 1,
        page_size: 10
      },
      isDialogVisible: false,
      selectedScope: null,
      oCPCInfo: null,
      monitorUrl: null,
      ocpc_info: null,
      appInfoDialogVisible: false,
      app_info: []
    }
  },
  created() {
    this.list()
  },
  methods: {
    list() {
      getBaiduADProjectFeedList(this.query).then(res => {
        this.baidudataList = res.data.list
        this.total = res.data.total
      })
    },
    openoCPC(row) {
      this.ocpc_info = row
      this.isDialogVisible = true
    },
    search() {
      this.list()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    appInfoLook(val) {
      this.app_info = val
      this.appInfoDialogVisible = true
    }
  }
}
</script>

<style scoped>
.allbox {
  padding: 30px;
}
.tag_box{
  margin: 0 10px 10px 0px;
}
.inptw {
  width: 250px;
}
.condition >* {
  margin-right: 10px;
}
</style>
